import { render, staticRenderFns } from "./salesstatic.vue?vue&type=template&id=2a045383&scoped=true&"
import script from "./salesstatic.vue?vue&type=script&lang=js&"
export * from "./salesstatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a045383",
  null
  
)

export default component.exports